import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Outlet, useLocation } from "react-router-dom";
import ReactLenis from "lenis/react";
import { Toaster } from "@/components/ui/sonner";

import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import ServiceDetail from "@/pages/ServiceDetail";
import Industries from "@/pages/Industries";
import Knowledge from "@/pages/Knowledge";
import KnowledgeArticle from "@/pages/KnowledgeArticle";
import CaseStudies from "@/pages/CaseStudies";
import Calculators from "@/pages/Calculators";
import ComplianceCalendar from "@/pages/ComplianceCalendar";
import FAQ from "@/pages/FAQ";
import Contact from "@/pages/Contact";
import Portal from "@/pages/Portal";
import BookConsultation from "@/pages/BookConsultation";
import Chatbot from "@/components/Chatbot";
import AuthCallback from "@/pages/AuthCallback";
import Admin from "@/pages/Admin";

// Synchronous check for OAuth callback — must run BEFORE Routes so the
// session_id in the URL fragment is processed exactly once.
function AppRouter() {
  const location = useLocation();
  if (location.hash && location.hash.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route element={<Layout><Outlet /></Layout>}>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/services/:slug" element={<ServiceDetail />} />
        <Route path="/industries" element={<Industries />} />
        <Route path="/knowledge" element={<Knowledge />} />
        <Route path="/knowledge/:slug" element={<KnowledgeArticle />} />
        <Route path="/case-studies" element={<CaseStudies />} />
        <Route path="/calculators" element={<Calculators />} />
        <Route path="/compliance-calendar" element={<ComplianceCalendar />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/book" element={<BookConsultation />} />
        <Route path="/portal" element={<Portal />} />
        <Route path="/admin" element={<Admin />} />
      </Route>
    </Routes>
  );
}

function App() {
  useEffect(() => {
    document.title = "CA Pankaj Talan And Advisory — Finance. Compliance. Growth.";
  }, []);
  return (
    <ReactLenis root options={{ lerp: 0.08, smoothWheel: true }}>
      <div className="App">
        <BrowserRouter>
          <AppRouter />
          <Chatbot />
        </BrowserRouter>
        <Toaster position="bottom-right" richColors />
      </div>
    </ReactLenis>
  );
}

export default App;
